import {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
} from "react";
import { api, setAuthToken, getAuthToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [token, setToken] = useState(getAuthToken());
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setAuthToken(null);
            setToken(null);
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (token) fetchMe();
        else setLoading(false);
    }, [token, fetchMe]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setAuthToken(data.access_token);
        setToken(data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        setAuthToken(null);
        setToken(null);
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ token, user, loading, login, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
